// src/features/owner/sections/analytics/EngagementSection.tsx
import { AnalyticsSection } from './AnalyticsSection';
export const EngagementSection = () => <AnalyticsSection kind="engagement" />;
